import { getDiscountPriceWithDefault, getVariantWeightPrice } from "./product";
import { isLandelijk } from "./region";
import { COUNTRY_BE, COUNTRY_NL } from "../constants/CountryConstants";
import {
  DISCOUNT_DELIVERY_FROM_PRICE_LANDELIJK,
  FREE_DELIVERY_FROM_PRICE_LANDELIJK,
  FREE_DELIVERY_FROM_PRICE_STANDARD,
  FREE_DELIVERY_FROM_PRICE_WEST_FRIESLAND,
  SEND_COST_DISCOUNT_LANDELIJK,
  SEND_COST_STANDARD,
  SEND_COST_STANDARD_LANDELIJK,
  SEND_COST_WEST_FRIESLAND,
  ZIPCODES_ENKHUIZEN,
  ZIPCODES_STEDE_BROEC,
  ZIPCODES_WEST_FRIESLAND,
} from "../constants/DeliveryConstants";

export const calculateDiscountPercentageTotalAmount = (
  cartItems,
  discountCode,
) => {
  let totalDiscountAmount = 0;
  cartItems.forEach((product) => {
    // Skip products with discount if code only applies to non-discounted products
    if (discountCode.applyOnlyToNonDiscountedProducts && product.discount > 0) {
      return;
    }

    let productPrice = getVariantWeightPrice(product);
    let discountPrice = getDiscountPriceWithDefault(
      productPrice,
      product.discount,
    );
    let discountAmountWithCode = calculateDiscountWithPercentage(
      discountPrice,
      discountCode.discountPercentage,
    );
    totalDiscountAmount += discountAmountWithCode * product.quantity;
  });
  return roundPriceTwoDecimals(totalDiscountAmount);
};

export const calculateDiscountAmountTotalAmount = (cartItems, discountCode) => {
  let quantity = 0;
  cartItems.forEach((product) => {
    // Skip products with discount if code only applies to non-discounted products
    if (discountCode.applyOnlyToNonDiscountedProducts && product.discount > 0) {
      return;
    }
    quantity += product.quantity;
  });
  return discountCode.discountAmount * quantity;
};

export const calculateDiscountWithPercentage = (price, percentage) => {
  return (price * percentage) / 100;
};

export const roundPriceTwoDecimals = (price) => {
  return Math.round(price * 100) / 100;
};

export const calculateShippingCost = (
  totalItemsPrice,
  totalGiftcardsPrice,
  deliveryValues,
) => {
  // Only gift cards -> free shipping
  if (totalItemsPrice === 0 && totalGiftcardsPrice > 0) return 0;

  const zip = deliveryValues?.zip;
  const isNL = deliveryValues?.country === COUNTRY_NL;
  if (!zip) return null; // unknown until user provides zip

  const landelijk = isLandelijk(zip);
  const cleaned = zip.toString().replace(/\s/g, "");
  const numericalZipcode = parseInt(cleaned);

  // Non-NL destinations: apply landelijk rates
  if (!isNL) {
    if (totalItemsPrice === 0) return 0;
    return SEND_COST_STANDARD_LANDELIJK;
  }

  if (landelijk) {
    if (totalItemsPrice === 0) return 0;
    else if (
      totalItemsPrice >= DISCOUNT_DELIVERY_FROM_PRICE_LANDELIJK &&
      totalItemsPrice < FREE_DELIVERY_FROM_PRICE_LANDELIJK
    )
      return SEND_COST_DISCOUNT_LANDELIJK;
    else if (totalItemsPrice < FREE_DELIVERY_FROM_PRICE_LANDELIJK)
      return SEND_COST_STANDARD_LANDELIJK;
    else if (totalItemsPrice > FREE_DELIVERY_FROM_PRICE_LANDELIJK) return 0;
    return SEND_COST_DISCOUNT_LANDELIJK;
  }

  // Regional defaults
  let cost =
    totalItemsPrice < FREE_DELIVERY_FROM_PRICE_STANDARD
      ? SEND_COST_STANDARD
      : 0;
  if (
    ZIPCODES_ENKHUIZEN.includes(numericalZipcode) ||
    ZIPCODES_STEDE_BROEC.includes(numericalZipcode)
  ) {
    cost =
      totalItemsPrice < FREE_DELIVERY_FROM_PRICE_STANDARD
        ? SEND_COST_STANDARD
        : 0;
  } else if (ZIPCODES_WEST_FRIESLAND.includes(numericalZipcode)) {
    cost =
      totalItemsPrice < FREE_DELIVERY_FROM_PRICE_WEST_FRIESLAND
        ? SEND_COST_WEST_FRIESLAND
        : 0;
  }
  return cost;
};

export const calculateRemainingForFreeShipping = (
  shippingCost,
  totalItemsPrice,
  deliveryValues,
) => {
  if (shippingCost == null || shippingCost === 0) return 0;
  if (totalItemsPrice <= 0) return 0;
  const zip = deliveryValues?.zip;
  // Belgium never gets free shipping
  if (deliveryValues?.country === COUNTRY_BE) return 0;
  if (deliveryValues?.country !== COUNTRY_NL) return 0;
  if (!zip) return 0;
  const cleaned = zip.toString().replace(/\s/g, "");
  const numericalZipcode = parseInt(cleaned);
  const landelijk = isLandelijk(zip);
  let threshold = FREE_DELIVERY_FROM_PRICE_STANDARD;
  if (landelijk) threshold = FREE_DELIVERY_FROM_PRICE_LANDELIJK;
  else if (ZIPCODES_WEST_FRIESLAND.includes(numericalZipcode))
    threshold = FREE_DELIVERY_FROM_PRICE_WEST_FRIESLAND;
  const remaining = threshold - totalItemsPrice;
  return remaining > 0 ? remaining : 0;
};
